import React, { useEffect, useState } from "react";
import "./DetallePago.css";
import { Link, useNavigate } from "react-router-dom";
import PopUpConCuantoPagas from "./PopUpConCuantoPagas";
import { Header1 } from "../../componentes/header/Header1";
import { userOrder } from '../../states/userOrder';
import { configShop } from '../../states/configShop';
import { apiGet, apiPost } from '../../utils/api';
import ListaPedido from "./ListaPedido";
import { ToastContainer, toast } from 'react-toastify';
import DeliveryMethods from "../Address/DeliveryMethods";
import { abrirCheckoutBold } from '../../utils/boldCheckout';
import { readableTextOn } from '../../utils/loyalty';
const IconCard = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="1" y="4" width="22" height="16" rx="2" />
    <line x1="1" y1="10" x2="23" y2="10" />
    <rect x="4" y="13" width="5" height="3" rx="1" />
  </svg>
);

const IconMoney = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="6" width="20" height="12" rx="2" />
    <circle cx="12" cy="12" r="3" />
    <path d="M6 6V4M18 6V4" />
  </svg>
);

const IconPhone = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="5" y="2" width="14" height="20" rx="2" />
    <line x1="12" y1="18" x2="12.01" y2="18" strokeWidth="3" />
  </svg>
);

const IconWallet = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 7H4a2 2 0 00-2 2v9a2 2 0 002 2h16a2 2 0 002-2V9a2 2 0 00-2-2z" />
    <path d="M16 3H8L4 7h16l-4-4z" />
    <circle cx="17" cy="13" r="1" fill="currentColor" />
  </svg>
);

const IconChevronRight = ({ size = 14, color }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color || "currentColor"} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

const IconArrowRight = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);

const IconPayment = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="1" y="4" width="22" height="16" rx="2" />
    <line x1="1" y1="10" x2="23" y2="10" />
    <line x1="5" y1="15" x2="9" y2="15" />
    <line x1="12" y1="15" x2="14" y2="15" />
  </svg>
);

const IconTruck = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="1" y="3" width="15" height="13" rx="1" />
    <path d="M16 8h4l3 5v4h-7V8z" />
    <circle cx="5.5" cy="18.5" r="2.5" />
    <circle cx="18.5" cy="18.5" r="2.5" />
  </svg>
);

const IconShoppingBag = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" />
    <line x1="3" y1="6" x2="21" y2="6" />
    <path d="M16 10a4 4 0 01-8 0" />
  </svg>
);

const IconGift = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="8" width="18" height="4" rx="1" />
    <path d="M12 8v13" />
    <path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7" />
    <path d="M7.5 8a2.5 2.5 0 0 1 0-5C10 3 12 8 12 8s2-5 4.5-5a2.5 2.5 0 0 1 0 5" />
  </svg>
);

const IconCheckCircle = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <polyline points="8 12.5 11 15.5 16 9.5" />
  </svg>
);

// PLZ-308: valores del premio en el mismo formato que la pre-orden ("$ 25.500").
const formatPesos = (value) => "$ " + Math.round(Number(value) || 0).toLocaleString("es-CO");

const PAYMENT_ICONS = {
  default: IconCard,
  1: IconMoney,
  2: IconCard,
  3: IconPhone,
  4: IconWallet,
};

export const DetallePago = ({
  codigoCurrency,
  codigoPais,
  propiedadesCompany,
  color_botton,
}) => {
  const { dataConfig } = configShop();
  const { dataUser, setDataUser } = userOrder();
  const [isDisabled, setIsDisabled] = useState(false);
  let navigate = useNavigate();

  const [popUpEntrega, setPopUpEntrega] = useState(false);
  const [metodoPago, setMetodoPago] = useState();
  const [preOrden, setPreOrden] = useState([]);
  const [indexPagoSeleccionada, setIndexPagoSeleccionada] = useState();
  const [listaMetodoDePago, setListaMetodoDePago] = useState([]);
  const [valorInput, setValorInput] = useState(0);
  // PLZ-308: codigo de premio. El descuento lo calcula el backend (pre-orden).
  const [rewardInput, setRewardInput] = useState("");
  const [rewardCode, setRewardCode] = useState("");
  const [rewardError, setRewardError] = useState("");
  const [rewardLoading, setRewardLoading] = useState(false);

  var valorEnPesos = parseInt(valorInput);

  const cartItems = JSON.parse(localStorage.getItem("infoProductoSeleccionado")) || [];
  const cartIsEmpty = cartItems.length === 0;

  useEffect(() => {
    obtenerMetodoDePago();
  }, [dataUser]);

  useEffect(() => {
    CalcularValor();
  }, [dataUser, rewardCode]);

  const reward = preOrden?.reward?.status === true ? preOrden.reward : null;
  const coversAll = reward?.covers_all === true;

  const aplicarCodigo = () => {
    const code = rewardInput.trim();
    if (!code) return;
    setRewardError("");
    setRewardLoading(true);
    setRewardCode(code);
  };

  const quitarCodigo = () => {
    setRewardInput("");
    setRewardCode("");
    setRewardError("");
  };

  const obtenerMetodoDePago = async () => {
    const respuesta = await apiGet('/type-pay');
    setListaMetodoDePago(respuesta.data);
  };

  const enviarInfoMetodoPago = (id) => {
    localStorage.setItem("Metodo de pago", id);
    setMetodoPago(id);
  };

  const enviarTotalAPagar = () => {
    if (coversAll) {
      enviarInfoOrdenMesas();
      return;
    }
    if (metodoPago === undefined) {
      toast.error('Seleccione método de pago', { position: "top-center", autoClose: 4000 });
      return;
    }
    if (metodoPago === 1) {
      const numero = parseInt(preOrden?.total_value?.replace(/[^\d]/g, ""), 10);
      if (valorEnPesos >= numero) {
        enviarInfoOrdenMesas();
      } else {
        setPopUpEntrega(true);
      }
    } else {
      enviarInfoOrdenMesas();
    }
  };

  const informacionProdSelecs = () => {
    let arrayToppings = [];
    let infoProductoSeleccionado = JSON.parse(localStorage.getItem("infoProductoSeleccionado")) || [];
    infoProductoSeleccionado.map((item) => {
      var listaToppings = [];
      item.toppings?.map((t) => {
        t.topingsSeleccionados?.map((s) => {
          listaToppings.push({ uuid_toppings: s.uuid, quantity: "1" });
        });
      });
      arrayToppings.push({
        uuid_product: item.idPlatoSelec,
        quantity: item.cantidadProducto,
        observations: "",
        toppings: listaToppings,
      });
    });
    return arrayToppings;
  };

  const enviarInfoOrdenMesas = async () => {
    setIsDisabled(true);
    let arrayListaProductos = informacionProdSelecs();
    let uuid_address = localStorage.getItem("uuid_address");

    if (metodoPago === null && !coversAll) {
      toast.error('Seleccione método de pago', { position: "top-center", autoClose: 4000 });
      setIsDisabled(false);
      return;
    }
    try {
      let dataOrders = {
        guests: dataUser,
        uuid_address,
        delivery_type: dataUser.deliveryMethod,
        payment_method_id: coversAll ? null : metodoPago,
        product: arrayListaProductos,
        dateDelivery: dataUser?.dateDelivery,
      };
      if (reward) {
        dataOrders.reward_code = reward.code;
      }
      const respuestaJSON = await apiPost('/orders-app-v3', dataOrders);
      if (respuestaJSON.success === "success") {
        const respuestaPago = respuestaJSON.data.pay;

        localStorage.setItem("pleiztService", respuestaJSON.data.service_id);
        localStorage.removeItem("infoProductoSeleccionado");
        localStorage.removeItem("Metodo de pago");

        // Bold: la pasarela se abre con el widget, no con una URL del backend.
        if (respuestaPago?.widget_params) {
          try {
            await abrirCheckoutBold(respuestaPago.widget_params);
            return; // Bold toma el control; no navegar al resumen.
          } catch (errorBold) {
            toast.error(
              'No se pudo abrir la pasarela de pago. Tu pedido quedo registrado.',
              { position: "top-center", autoClose: 5000 }
            );
            navigate("/resumenPedido/" + respuestaJSON.data.service_id);
            return;
          }
        }

        // Wompi: redireccion por URL armada en el backend.
        if (respuestaPago?.status === true && respuestaPago?.url) {
          window.location.replace(respuestaPago.url);
          return;
        }

        navigate("/resumenPedido/" + respuestaJSON.data.service_id);
      } else {
        toast.error(respuestaJSON.message, { position: "top-center", autoClose: 5000 });
        setIsDisabled(false);
      }
    } catch (err) {
      setIsDisabled(false);
    }
  };

  const CalcularValor = async () => {
    let metodoPagoLS = localStorage.getItem("Metodo de pago");
    let uuid_address = localStorage.getItem("uuid_address");
    let arrayListaProductos = informacionProdSelecs();
    try {
      const respuestaJSON = await apiPost('/pre-orders-app-v2', {
        guests: dataUser,
        uuid_address,
        delivery_type: dataUser.deliveryMethod,
        payment_method_id: metodoPagoLS,
        product: arrayListaProductos,
        ...(rewardCode ? { reward_code: rewardCode } : {}),
      });
      if (respuestaJSON.success === "success") {
        const premio = respuestaJSON.data?.reward;
        if (rewardCode && premio && premio.status !== true) {
          // Codigo rechazado: se muestra el motivo y se vuelve a calcular sin codigo.
          setRewardError(premio.message || "Código no válido");
          setRewardCode("");
        }
        setPreOrden(respuestaJSON.data);
      } else {
        toast.error(respuestaJSON.message, { position: "top-center", autoClose: 5000 });
      }
    } catch (err) {
      console.log(err);
    } finally {
      setRewardLoading(false);
    }
  };

  const brandColor = dataConfig?.page_menu?.button?.color;
  const brandText = dataConfig?.page_menu?.button?.color_text;
  // PLZ-308: texto de los botones legible sobre el color del comercio (blanco sobre amarillo no se lee).
  const brandTextOnButton = readableTextOn(brandColor, brandText);

  return (
    <div className="App">
      <div className="dp-page">
        <header className="App-header">
          <Header1 propiedadesCompany={propiedadesCompany} />
        </header>

        <div className="dp-scroll">

          {/* Entrega */}
          <div className="rg-section-card">
            <div className="rg-section-header">
              <span className="rg-section-icon" style={{ color: brandColor }}><IconTruck size={18} /></span>
              <span className="rg-section-title">Datos de entrega</span>
            </div>
            <DeliveryMethods />
          </div>

          {/* Productos */}
          <div className="rg-section-card">
            <div className="rg-section-header">
              <span className="rg-section-icon" style={{ color: brandColor }}><IconShoppingBag size={18} /></span>
              <span className="rg-section-title">Tu pedido</span>
            </div>
            {cartIsEmpty ? (
              <div className="dp-empty-cart">
                <span className="dp-empty-cart-icon" style={{ color: brandColor }}><IconShoppingBag size={32} /></span>
                <span className="dp-empty-cart-text">Tu carrito está vacío</span>
                <span className="dp-empty-cart-sub">Agrega productos para continuar</span>
              </div>
            ) : (
              <ListaPedido />
            )}
          </div>

          {/* PLZ-308: código de premio */}
          {!cartIsEmpty && (
            <div className="rg-section-card">
              <div className="rg-section-header">
                <span className="rg-section-icon" style={{ color: brandColor }}><IconGift size={18} /></span>
                <span className="rg-section-title">¿Tienes un código de premio?</span>
              </div>
              {reward ? (
                <>
                  <div className="dp-reward-applied">
                    <span className="dp-reward-applied-icon"><IconGift size={20} /></span>
                    <div className="dp-reward-applied-info">
                      <span className="dp-reward-applied-title">Premio {reward.program_name}</span>
                      <span className="dp-reward-applied-code">{reward.code}</span>
                    </div>
                    <span className="dp-reward-applied-value">−{formatPesos(reward.discount)}</span>
                  </div>
                  {reward.message && <p className="dp-reward-note">{reward.message}</p>}
                  <button className="dp-reward-remove" onClick={quitarCodigo}>Quitar código</button>
                </>
              ) : (
                <>
                  <div className="dp-reward-row">
                    <input
                      className={`dp-reward-input ${rewardError ? "dp-reward-input--error" : ""}`}
                      style={{ "--btn-color": brandColor }}
                      placeholder="Código de 8 caracteres"
                      maxLength={12}
                      autoCapitalize="characters"
                      autoComplete="off"
                      value={rewardInput}
                      onChange={(e) => { setRewardInput(e.target.value); setRewardError(""); }}
                      onKeyDown={(e) => { if (e.key === "Enter") aplicarCodigo(); }}
                    />
                    <button
                      className="dp-reward-apply"
                      style={{ "--btn-color": brandColor, "--btn-text": brandTextOnButton }}
                      onClick={aplicarCodigo}
                      disabled={!rewardInput.trim() || rewardLoading}
                    >
                      {rewardLoading ? <span className="rg-btn-spinner" /> : "Aplicar"}
                    </button>
                  </div>
                  {rewardError && <p className="dp-reward-error">{rewardError}</p>}
                </>
              )}
            </div>
          )}

          {/* Método de pago */}
          <div className="rg-section-card">
            <div className="rg-section-header">
              <span className="rg-section-icon" style={{ color: brandColor }}><IconPayment size={18} /></span>
              <span className="rg-section-title">Método de pago</span>
            </div>
            {coversAll ? (
              <div className="dp-covered">
                <span className="dp-covered-icon"><IconCheckCircle size={22} /></span>
                <span>Tu premio cubre todo el pedido, no tienes que pagar nada.</span>
              </div>
            ) : (
            <div className="dp-payment-grid">
              {listaMetodoDePago?.map((item, i) => {
                const Icon = PAYMENT_ICONS[item.id] || PAYMENT_ICONS.default;
                const isActive = i === indexPagoSeleccionada;
                return (
                  <button
                    key={item.id}
                    className={`dp-payment-card ${isActive ? "dp-payment-card--active" : ""}`}
                    style={{
                      "--pay-brand": brandColor,
                      "--pay-brand-text": brandText,
                    }}
                    onClick={() => {
                      enviarInfoMetodoPago(item.id);
                      setMetodoPago(item.id);
                      setIndexPagoSeleccionada(i);
                    }}
                  >
                    <div className="dp-payment-icon-wrap">
                      <Icon size={20} />
                    </div>
                    <span className="dp-payment-name">{item.name}</span>
                    {isActive && <span className="dp-payment-check">✓</span>}
                  </button>
                );
              })}
            </div>
            )}
          </div>

          {/* ¿Con cuánto pagas? — solo efectivo */}
          {metodoPago === 1 && !coversAll && (
            <button
              className="dp-cash-row"
              onClick={() => setPopUpEntrega(true)}
            >
              <div className="dp-cash-left">
                <span style={{ color: brandColor, display: "flex" }}><IconMoney size={18} /></span>
                <div className="dp-cash-info">
                  <span className="dp-cash-label">¿Con cuánto pagas?</span>
                  <span className="dp-cash-value">
                    {valorEnPesos > 0
                      ? valorEnPesos.toLocaleString(codigoPais, { style: "currency", minimumFractionDigits: 0, maximumFractionDigits: 0, currency: codigoCurrency })
                      : "Toca para ingresar el valor"}
                  </span>
                </div>
              </div>
              <IconChevronRight size={14} color="#AAAAB5" />
            </button>
          )}

          <div className="dp-bottom-spacer" />
        </div>

        {/* Footer fijo: resumen + botones */}
        <div className="dp-footer">
          <div className="dp-summary">
            <div className="dp-summary-row">
              <span>Subtotal</span>
              <span>{preOrden.base_value}</span>
            </div>

            {preOrden?.deivery_discount?.status === true && (
              <div className="dp-summary-row dp-summary-discount">
                <span>Descuento domicilio</span>
                <span>- {preOrden.deivery_discount.value}</span>
              </div>
            )}

            {reward && (
              <div className="dp-summary-row dp-summary-discount">
                <span>Premio</span>
                <span>- {formatPesos(reward.discount)}</span>
              </div>
            )}

            {String(dataUser?.deliveryMethod) === "2" ? (
              <div className="dp-summary-row">
                <span>Recoges en tienda</span>
                <span>Sin domicilio</span>
              </div>
            ) : (
              <div className="dp-summary-row">
                <span>Domicilio</span>
                <span>{preOrden.delivery_value}</span>
              </div>
            )}

            <div className="dp-summary-divider" />

            <div className="dp-summary-row dp-summary-total">
              <span>Total</span>
              <span>{preOrden.total_value}</span>
            </div>
          </div>

          <div className="dp-action-row">
            <Link to="/shoppingCart/" style={{ textDecoration: "none" }}>
              <button className="dp-btn-cancel">Cancelar</button>
            </Link>
            <button
              className="dp-btn-pay"
              onClick={enviarTotalAPagar}
              disabled={isDisabled}
              style={{ "--btn-color": brandColor, "--btn-text": brandTextOnButton }}
            >
              {isDisabled ? (
                <span className="rg-btn-spinner" />
              ) : (
                <>
                  <span>{coversAll ? "Confirmar pedido" : "Pagar"}</span>
                  <IconArrowRight size={14} />
                </>
              )}
            </button>
          </div>
        </div>

        <PopUpConCuantoPagas
          popUpEntrega={popUpEntrega}
          setPopUpEntrega={setPopUpEntrega}
          setValorInput={setValorInput}
          valorInput={valorInput}
          codigoPais={codigoPais}
          codigoCurrency={codigoCurrency}
          propiedadesCompany={propiedadesCompany}
          color_botton={brandColor}
          btnTextColor={brandText}
          TotalValue={preOrden.total_value}
        />
      </div>
      <ToastContainer />
    </div>
  );
};
